

































































































































































































import { Component, Prop, Mixins, Vue } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import IProjectOutput from "@/api/models/IProjectOutput";
import IOrderOutput from "@/api/models/IOrderOutput";
import { Company, Office } from "@/api/company-api";
import VDelete from "../components/VDelete.vue";
import SwitchButton from "@/components/SwitchButton.vue";
import ProjectPropertiesForm from "@/components/project/property/ProjectPropertiesForm.vue";
import ProjectTaskDefaultsForm from "@/components/project/property/ProjectTaskDefaultsForm.vue";
import { EnvironmentMixin } from "@/helpers/environment-mixin";
import Decimal from "decimal.js";
import emitter from "@/EventBus";
import { ProjectPropertyKey } from "@/api/project/project-properties-api";
import { isNewProject } from "@/preferences";
import {
  ConstructionType,
  getConstructionTypes
} from "@/api/project/construction-types-api";
import ProjectManager from "@/entities/project-manager";

@Component({
  components: {
    ProjectPropertiesForm,
    ProjectTaskDefaultsForm,
    VDelete,
    SwitchButton
  },
  methods: {
    isNewProject
  }
})
export default class ProjectEdit extends Mixins<EnvironmentMixin>() {
  @Prop({ required: true }) project!: IProjectOutput;
  @Prop({ required: true }) order!: IOrderOutput;
  @Prop({ required: true }) company!: Company;
  @Prop({ required: true }) office!: Office;
  @Prop({ default: () => [] }) clientOptions!: SelectOption[];
  @Prop({ default: () => [] }) clientStaffOptions!: SelectOption[];
  @Prop({ default: () => [] }) templateOptions!: SelectOption[];

  status = "";
  error: string = "";
  contractDate = this.project.contractDate;
  defaultKey: ProjectPropertyKey[] = [];
  constructionTypes: ConstructionType[] = [];
  endDate = this.project.end;

  get service() {
    return this.$store.state.service;
  }

  checkClient(checkBoxStatus: any) {
    if (checkBoxStatus) {
      this.company.client = false;
    } else {
      this.company.client = true;
    }
  }

  get profitRate(): string {
    if (this.office.profitRate === null) {
      return "";
    }
    return String(new Decimal(this.office.profitRate).mul(100));
  }

  set profitRate(profitRate: string) {
    if (!profitRate) {
      this.office.profitRate = null;
      return;
    }
    this.office.profitRate = new Decimal(profitRate).div(100).toNumber();
  }

  ok() {
    let hasEndDateChanged = this.endDate !== this.project.end;
    if (
      new Date(this.project.start).getTime() >
        new Date(this.project.end).getTime() &&
      this.project.end != null &&
      isNewProject(this.project.created)
    ) {
      alert("指定完了日が不正です。");

      return;
    }

    if (
      this.project.templateId &&
      !confirm("工程表のテンプレートを反映してもよろしいですか？")
    ) {
      return;
    }

    if (
      hasEndDateChanged &&
      !confirm("完了日になりましたら、現場を終了してもよろしでしょうか？")
    ) {
      return;
    }

    this.status = "progressing";
    this.$emit("ok", hasEndDateChanged);
    emitter.on("message", (e: any) => {
      this.status = "";
      this.error = e[0];
    });
  }

  get isRequired(): boolean {
    if (this.contractDate && this.contractDate !== "0000-00-00") {
      return true;
    }

    return false;
  }

  cancel() {
    this.$emit("cancel");
  }

  remove() {
    this.$emit("remove");
  }

  beforeDestroy() {
    emitter.off("message");
  }

  created() {
    this.initConstructionTypes();
  }

  get newProject() {
    if (this.project.created) {
      if (isNewProject(this.project.created)) {
        return true;
      }
    }

    return false;
  }

  private async initConstructionTypes() {
    if (this.newProject) {
      this.constructionTypes = await getConstructionTypes();
    }
  }

  get constructionTypeOptions(): SelectOption[] {
    return [
      {
        text: "なし",
        value: ""
      }
    ].concat(
      this.constructionTypes.map(s => ({
        text: s.name,
        value: String(s.id)
      }))
    );
  }

  private get assignedManagers() {
    if (!this.newProject) return [];

    const defaultPerson = [
      {
        text: "",
        value: ""
      }
    ];
    let data = this.$store.getters["member/assigned-managers"];
    if (this.$route.name == "project-new") {
      data = this.$store.state.user;

      return [
        ...defaultPerson,
        {
          text: data.name,
          value: data.staffId
        }
      ];
    }

    return defaultPerson.concat(
      data
        .filter((item: ProjectManager) => !item.isHiddenInfo)
        .map((item: ProjectManager) => ({
          text: item.name,
          value: String(item.id)
        }))
    );
  }

  handleOpenCalendar() {
    ((this.$refs.calendar as Vue).$el as any).showPicker();
  }
}
